import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../../../store'
import { SnackbarActions } from '../../../../../store/snackbar'
import { MatchedPFActions, MatchedPFSelector } from '../../../../../store/matchedPF'
import { PrivateFoundationDetail } from '../../../../../components/PrivateFoundationDetail'

interface ProjectGrantProps {
  projectId: string
  refId: string
}

export const ProjectPF: FC<ProjectGrantProps> = ({ projectId, refId }) => {
  const dispatch = useDispatch<AppDispatch>()

  const pf = useSelector(MatchedPFSelector.makeMatchedPF)

  useEffect(() => {
    fetchProjectPF().then()
  }, [projectId, refId])

  const fetchProjectPF = async () => {
    try {
      if (!projectId || !refId) return

      await dispatch(MatchedPFActions.fetchMatchedPFAsync({
        technologyId: projectId,
        refId,
        options: { params: { $includes: 'privateFoundation' } },
      }))
    } catch (error: any) {
      dispatch(SnackbarActions.showSnackbar({ message: error.message }))
    }
  }

  return (
    <PrivateFoundationDetail privateFoundation={pf} />
  )
}
